/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOrgForCollectionMembershipQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetOrgForCollectionMembershipQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly displayName: string;
    readonly hasCustomAppIcon: boolean;
    readonly allowWorkspaceSharing: boolean;
    readonly userCount: number;
    readonly sharedCollectionCount: number;
  };
};

export const GetOrgForCollectionMembershipDocument = /*#__PURE__*/ gql`
  query GetOrgForCollectionMembership($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      displayName
      hasCustomAppIcon
      allowWorkspaceSharing
      userCount(
        activeFilter: ONLY_ACTIVE
        orgRoleFilter: [ADMIN, MANAGER, EDITOR, EXPLORER, MEMBER]
      )
      sharedCollectionCount
    }
  }
`;

/**
 * __useGetOrgForCollectionMembershipQuery__
 *
 * To run a query within a React component, call `useGetOrgForCollectionMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgForCollectionMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgForCollectionMembershipQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgForCollectionMembershipQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgForCollectionMembershipQuery,
    GetOrgForCollectionMembershipQueryVariables
  > &
    (
      | {
          variables: GetOrgForCollectionMembershipQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgForCollectionMembershipQuery,
    GetOrgForCollectionMembershipQueryVariables
  >(GetOrgForCollectionMembershipDocument, options);
}
export function useGetOrgForCollectionMembershipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgForCollectionMembershipQuery,
    GetOrgForCollectionMembershipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgForCollectionMembershipQuery,
    GetOrgForCollectionMembershipQueryVariables
  >(GetOrgForCollectionMembershipDocument, options);
}
export function useGetOrgForCollectionMembershipSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgForCollectionMembershipQuery,
    GetOrgForCollectionMembershipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgForCollectionMembershipQuery,
    GetOrgForCollectionMembershipQueryVariables
  >(GetOrgForCollectionMembershipDocument, options);
}
export type GetOrgForCollectionMembershipQueryHookResult = ReturnType<
  typeof useGetOrgForCollectionMembershipQuery
>;
export type GetOrgForCollectionMembershipLazyQueryHookResult = ReturnType<
  typeof useGetOrgForCollectionMembershipLazyQuery
>;
export type GetOrgForCollectionMembershipSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgForCollectionMembershipSuspenseQuery
>;
export type GetOrgForCollectionMembershipQueryResult = Apollo.QueryResult<
  GetOrgForCollectionMembershipQuery,
  GetOrgForCollectionMembershipQueryVariables
>;
